export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-01T13:07:28",
  lastPipeline: "6459",
  version: "0.0.0",
  sentryDsn: '',
};
